/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import TimezoneSelect from '../../timezone/TimezoneSelect';

const AdvFormTimeZoneSelectItem = React.memo(({
  formField, pageData, setPageData, loginData,
}) => {
  const {
    id, value: formValue, apiFullPath,
  } = formField;

  const handleOnChange = (timezone) => {
    const updatedPageData = { ...pageData };
    updatedPageData.formFields[id].value = timezone;
    setPageData(updatedPageData);
  };

  return (
    <div>
      <TimezoneSelect
        value={formValue}
        onChange={handleOnChange}
        loginData={loginData}
        apiFullPath={apiFullPath}
      />

    </div>
  );
});

export default AdvFormTimeZoneSelectItem;
